'use strict';

var keyMirror = require('react/lib/keyMirror');

var DragDropActionTypes = keyMirror({
  DRAG_START: null,
  DRAG_END: null,
  DROP: null
});

module.exports = DragDropActionTypes;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/constants/DragDropActionTypes.js
 ** module id = 73
 ** module chunks = 0
 **/